import countDown from './count-down.vue';

export default {
  install(application) {
    application.component('yx-count-down', countDown);
  },
};
